<template>
  <div class="auth-wrapper auth-v2">
    <b-overlay :show="show" no-wrap />
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <div class="brand-logo">
        <img src="@/assets/images/logo/logoNew.svg" />
        <div class="brand-logo-text">
          Human Resource System
        </div>
      </div>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center ">
        <div class="w-100 d-lg-flex align-items-center justify-content-center ">
          <b-img
            style="width: 100%;height: auto;"
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="font-weight-bold mb-1 fw-7 black-text ">
            Welcome to HR System!
          </b-card-title>
          <b-card-text class="mb-1 secondary-text ">
            Please sign-in to your account and start the adventure
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form class="auth-login-form mcc-formGroup " @submit.prevent>
              <!-- email -->
              <b-form-group label="Account" label-for="login-email">
                <validation-provider
                  #default="{ errors }"
                  name="Account"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="loginForm.username"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="employee code,number or email"
                  />
                  <small v-if="errors[0]" class="text-danger">{{
                    i18n('login.accountTip')
                  }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="loginForm.password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Key in password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small v-if="errors[0]" class="text-danger">{{
                    i18n('login.passwordTip')
                  }}</small>
                </validation-provider>
              </b-form-group>
              <div class="flex just-sb mb-1">
                <div class="fw-7 primary-text cursor-pointer" @click="toSms">
                  Sign in with SMS
                </div>
                <div
                  class=" fw-7 secondary-text cursor-pointer"
                  @click="openForget"
                >
                  Forget Password
                </div>
              </div>

              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group> -->

              <!-- submit buttons -->
              <b-button
                type="submit"
                block
                class="linear-gradient-1 mcc-btn-padding line-22 fw-5"
                @click="handleLogin"
              >
                Sign in
              </b-button>
              <!-- <b-button
                type="submit"
                variant="primary"
                block
                @click="validationForm"
              >
                Sign in
              </b-button> -->
            </b-form>
          </validation-observer>
          <div class="mt-1 secondary-text fw-5 line-22">
            Or,Sign in with
            <span class="primary-text fw-7 cursor-pointer" @click="handlePortal"
              >MCC Portal</span
            >
          </div>
        </b-col>
      </b-col>
    </b-row>
    <a-modal
      v-if="isInitPasswordFlag"
      :visible="isInitPasswordFlag"
      :title="'Please change the password!'"
      :width="950"
      z-index="999"
      :mask-closable="false"
      :footer="null"
      @cancel="cancel"
    >
      <password />
    </a-modal>
    <a-modal
      v-if="showResetBlock"
      :visible="showResetBlock"
      :title="'Reset password'"
      :width="950"
      z-index="999"
      :mask-closable="false"
      :footer="null"
      @cancel="cancelResetBlock"
    >
      <ResetPassword />
    </a-modal>
    <c-drawer
      class="forgetBox"
      v-model="forgetPassword_show"
      @handleClose="closeForget"
      @handleConfirm="confirmForget"
      title="Reset Password"
      :confirmLoading="confirmLoading"
    >
      <validation-observer ref="resetPasswordValidation">
        <b-form class="auth-login-form mcc-formGroup " @submit.prevent>
          <b-form-group>
            <div class="d-flex justify-content-between">
              <label for="login-password"
                >Which way you prefer to reset password?</label
              >
            </div>
            <validation-provider
              #default="{ errors }"
              name="resetType"
              rules="required"
            >
              <div class="flex gap-24 group-item">
                <b-form-radio
                  v-model="resetPasswordForm.type"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="A"
                  ><span class="text-606266">Phone Number</span></b-form-radio
                >
                <b-form-radio
                  v-model="resetPasswordForm.type"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="B"
                  ><span class="text-606266">MCC Email</span></b-form-radio
                >
              </div>

              <small v-if="errors[0]" class="text-danger">{{
                i18n('login.accountTip')
              }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group v-if="resetPasswordForm.type === 'B'">
            <div class="d-flex justify-content-between">
              <label for="login-password">Email</label>
            </div>
            <validation-provider
              #default="{ errors }"
              name="resetType"
              rules="required"
            >
              <b-form-input
                id="login-email"
                v-model="resetPasswordForm.email"
                :state="errors.length > 0 ? false : null"
                name="login-email"
              />
              <small v-if="errors[0]" class="text-danger">{{
                i18n('login.emailTip')
              }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group v-else>
            <div class="d-flex justify-content-between">
              <label for="login-password">Phone Number</label>
            </div>
            <validation-provider
              #default="{ errors }"
              name="phone"
              rules="required"
            >
              <div class="flex gap-8 flex-alignItem">
                <el-input
                  placeholder="Mobile"
                  v-model="resetPasswordForm.phone"
                  type="number"
                >
                  <el-select
                    style="width: 90px"
                    v-model="resetPasswordForm.phoneQh"
                    slot="prepend"
                    filterable
                    :filter-method="customFilter"
                  >
                    <el-option
                      v-for="country in filteredCountries"
                      :key="country.code"
                      :label="country.nameLabel"
                      :value="country.zone"
                    >
                    </el-option>
                  </el-select>
                </el-input>
                <!-- <div style="width:100px">
                  <b-form-select
                    v-model="resetPasswordForm.phoneQh"
                    :options="options"
                  ></b-form-select>
                </div>
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    v-model="resetPasswordForm.phone"
                    :state="errors.length > 0 ? false : null"
                    class="form-control-merge"
                    type="number"
                  />
                </b-input-group> -->
              </div>

              <small v-if="errors[0]" class="text-danger">{{
                i18n('login.phoneTip')
              }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group>
            <div class="d-flex justify-content-between">
              <label>OTP Code</label>
            </div>
            <validation-provider
              #default="{ errors }"
              name="otpCode"
              rules="required"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  autocomplete="off"
                  v-model="resetPasswordForm.otpCode"
                  :state="errors.length > 0 ? false : null"
                  class="form-control-merge"
                />
                <b-input-group-append is-text>
                  <div v-if="sendTimes <= 0">
                    <a-button
                      class="mcc-btn-border"
                      :loading="sendLoading"
                      @click="sendCode"
                    >
                      Send Code</a-button
                    >
                  </div>
                  <div v-else>
                    <a-button class="mcc-btn-border" :loading="sendLoading">
                      {{ sendTimes }} s</a-button
                    >
                  </div>
                </b-input-group-append>
              </b-input-group>
              <small v-if="errors[0]" class="text-danger">{{
                i18n('login.otpCodeTip')
              }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group>
            <div class="d-flex justify-content-between">
              <label>New Password</label>
            </div>
            <validation-provider
              #default="{ errors }"
              name="newPassword"
              rules="required"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  v-model="resetPasswordForm.newPassword"
                  autocomplete="off"
                  :state="errors.length > 0 ? false : null"
                  class="form-control-merge"
                  placeholder=""
                  name="mcc-nws"
                  :type="newPasswordType"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="newPasswordToggleIcon"
                    @click="changePasswordType('newPasswordType')"
                  />
                </b-input-group-append>
              </b-input-group>
              <small v-if="errors[0]" class="text-danger">{{
                i18n('login.passwordTip')
              }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group>
            <div class="d-flex justify-content-between">
              <label>Confirm New Password</label>
            </div>
            <validation-provider
              #default="{ errors }"
              name="confirmNewPassword"
              :rules="
                `required|confirmPassword:${resetPasswordForm.newPassword}`
              "
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  v-model="resetPasswordForm.confirmNewPassword"
                  :state="errors.length > 0 ? false : null"
                  class="form-control-merge"
                  name="confirmNewPassword"
                  :type="confirmPasswordType"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="confirmPasswordToggleIcon"
                    @click="changePasswordType('confirmPasswordType')"
                  />
                </b-input-group-append>
              </b-input-group>
              <small v-if="errors[0]" class="text-danger">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-form>
      </validation-observer>
    </c-drawer>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
extend('confirmPassword', {
  validate(value, password) {
    console.log('sssssssss', value, password)
    if (password) {
      return value == password
    }
    return false
  },
  message: 'The two password inputs are inconsistent',
})

extend('phoneNumberS', (value, phoneNumber) => {
  console.log(phoneNumber)
  return phoneNumber[0] !== ''
})

import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BFormSelect,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BOverlay,
  BFormRadio,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import { resetRouter } from '@/router/index'
import Password from '@/views/common/Password.vue'
import ResetPassword from '@/views/common/resetPassword.vue'
import {
  loginByAiisToken,
  sendForgetPasswordSms,
  sendResetPasswordEmail,
  resetPasswordBySms,
  resetPasswordByEmail,
} from '@/api/user'
import { getToken } from '@/util/auth'
import CDrawer from '@/components/drawerNew.vue'
import { password } from '@/@core/utils/validations/validations'
import md5 from 'js-md5'
import { deepClone } from '@/util/util'
import countryCode from '@/util/mobileCode'
export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormSelect,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    CDrawer,
    BButton,
    BFormRadio,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    BOverlay,
    Password,
    ResetPassword,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      forgetPassword_show: false,
      sendLoading: false,
      sendTimes: 0,
      sendTimer: '',
      sideImg: require('@/assets/images/logo/vector-sign-in.png'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      show: false,
      confirmLoading: false,
      newPasswordType: 'password',
      confirmPasswordType: 'password',
      resetPasswordForm: {
        phoneQh: '+65',
        type: 'A',
        phone: '',
        newPassword: null,
        confirmNewPassword: null,
        otpCode: null,
      },
      options: [
        { value: '65', text: '+ 65' },
        { value: '86', text: '+ 86' },
      ],
      countries: [],
      filteredCountries: [],
      loginForm: {
        tenantId: '000000',
        username: '',
        password: '',
        type: 'account',
        // image: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      },
      showResetBlock: false,
    }
  },
  mounted() {
    const newCountryCode = countryCode
    this.countries = newCountryCode
    this.filteredCountries = [...this.countries]
    const loginInfo = JSON.parse(localStorage.getItem('loginInfo'))
    if (loginInfo.password || loginInfo.password.username) {
      this.loginForm = loginInfo
    }
    console.log('..................登录页面加载')
    this.$store.commit('getIsInitPassWordStatus', false)
  },
  created() {
    if (getToken()) {
      this.$router.replace({ path: '/homePage' })
      return
    }
    const { token } = this.$route.query
    if (token) {
      this.show = true
      const params = {
        aiis_token: token,
        grant_type: 'aiis_token',
      }
      loginByAiisToken(params)
        .then(async (res) => {
          const { data } = res
          if (data.access_token) {
            this.$store.commit('SET_AIIS_TOKEN', token)
            this.$store.commit('SET_TOKEN', data.access_token)
            this.$store.commit('saveUserInfo', data)
            this.$store.commit('SET_REFRESH_TOKEN', data.refresh_token)
            this.$store.commit('SET_TENANT_ID', data.tenant_id)
            this.$store.commit('SET_USER_INFO', data)

            await this.$store.dispatch('GetUserInfo')
            await this.$store.dispatch('GetDicts')
            await this.$store.dispatch('GetTemplateForm')

            this.$router.push({ path: '/homePage' })
            this.show = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'SUCCESS',
                icon: 'BellIcon',
                text: 'login success ',
                variant: 'success',
              },
            })
          }
        })
        .catch((e) => {
          this.show = false
        })
    }
  },
  watch: {
    'resetPasswordForm.type': {
      handler(newValue, oldValue) {
        clearInterval(this.sendTimer)
        this.sendTimes = 0
        this.resetPasswordForm = {
          phoneQh: '+65',
          type: newValue,
          phone: '',
          newPassword: null,
          confirmNewPassword: null,
          otpCode: null,
        }
      },
    },
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    newPasswordToggleIcon() {
      return this.newPasswordType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    confirmPasswordToggleIcon() {
      return this.confirmPasswordType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/logo/vector-sign-in.png')
        return this.sideImg
      }
      return this.sideImg
    },
    isOverTime() {
      let isOverTime = false
      if (this.userAllInfo.updatePasswordTime) {
        const currentTime = moment(new Date())
        const time = moment(this.updatePasswordTime).add(90, 'days')
        const date = moment.max(currentTime, time).format('YYYY-MM-DD')
        isOverTime = moment.max(currentTime, time) === currentTime
      }
      return isOverTime
    },
    ...mapGetters([
      'tagWel',
      'isInitPasswordFlag',
      'userAllInfo',
      'tempUserInfo',
    ]),
  },
  beforeDestroy() {
    clearInterval(this.sendTimer)
  },
  methods: {
    customFilter(query) {
      // en: item.en,
      //   cn: item.cn,
      //   code: item.code,
      //   zone
      console.log(query)
      const searchTerm = query.toLowerCase()

      this.filteredCountries = this.countries.filter((country) => {
        return (
          country.en.toLowerCase().includes(searchTerm) || // 匹配国家名称
          country.cn.toLowerCase().includes(searchTerm) ||
          country.code.toLowerCase().includes(searchTerm) ||
          country.zone.toLowerCase().includes(searchTerm)
          // 匹配区号
        )
      })
    },
    handleLogin() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          this.show = true
          const loginForm = deepClone(this.loginForm)
          loginForm.username = this.loginForm.username.trim()
          this.$store
            .dispatch('LoginByUsername', loginForm)
            .then((res) => {
              // if (this.isOverTime) {
              //   this.$store.commit('getIsInitPassWordStatus', true)
              // }
              // this.$router.push({ path: this.tagWel.value })
              localStorage.setItem('loginInfo', JSON.stringify(loginForm))
              resetRouter()
              this.$router.push({ path: '/homePage' })
              this.show = false
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'SUCCESS',
                  icon: 'BellIcon',
                  text: 'login success ',
                  variant: 'success',
                },
              })
            })
            .catch((e) => {
              this.show = false
              // this.refreshCode()
            })
        }
      })
    },
    handlePortal() {
      this.$router.push('/loginByMCCPortal')
    },
    confirmForget() {
      if (this.confirmLoading) {
        return
      }
      console.log(this.resetPasswordForm)
      this.$refs.resetPasswordValidation.validate().then((success) => {
        if (success) {
          const trimPhone = this.resetPasswordForm.phone
            ? this.resetPasswordForm.phone.trim()
            : ''
          const params = {
            phone: `${this.resetPasswordForm.phoneQh} ${trimPhone}`,
            verifyCode: this.resetPasswordForm.otpCode.trim(),
            password: md5(this.resetPasswordForm.newPassword),
            email: this.resetPasswordForm.email
              ? this.resetPasswordForm.email.trim()
              : '',
          }
          const submitFun =
            this.resetPasswordForm.type === 'A'
              ? resetPasswordBySms
              : resetPasswordByEmail
          this.confirmLoading = true

          submitFun(params)
            .then((res) => {
              this.confirmLoadingTimer = setTimeout(() => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'SUCCESS',
                    icon: 'BellIcon',
                    text: 'success ',
                    variant: 'success',
                  },
                })
                this.confirmLoading = false
                this.forgetPassword_show = false
              }, 2000)
            })
            .catch((err) => {
              this.confirmLoading = false
              // this.forgetPassword_show = false
            })
        }
      })
    },
    sendCode() {
      if (this.resetPasswordForm.type === 'A') {
        this.sendPhone()
      } else {
        this.sendEmail()
      }
    },
    sendEmail() {
      console.log(this.resetPasswordForm)
      if (!this.resetPasswordForm.email) {
        this.$toast({
          component: ToastificationContent,
          props: {
            icon: 'BellIcon',
            text: 'please enter email',
            variant: 'danger',
          },
        })
        return
      }
      this.sendLoading = true
      sendResetPasswordEmail({ email: this.resetPasswordForm.email.trim() })
        .then((res) => {
          console.log(res)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'SUCCESS',
              icon: 'BellIcon',
              text: 'send success',
              variant: 'success',
            },
          })
          this.sendLoading = false
          this.sendTimes = 60
          this.sendTimer = setInterval(() => {
            if (this.sendTimes > 0) {
              this.sendTimes--
            } else {
              clearInterval(this.sendTimer)
            }
          }, 1000)
        })
        .catch((err) => {
          this.sendLoading = false
        })
    },
    changePasswordType(e) {
      console.log(this[e] == 'password')
      this[e] = this[e] === 'password' ? 'null' : 'password'
    },
    getPasswordIcon(e) {
      return this[e] === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    sendPhone() {
      console.log(this.resetPasswordForm)
      if (!this.resetPasswordForm.phone) {
        this.$toast({
          component: ToastificationContent,
          props: {
            icon: 'BellIcon',
            text: 'please enter phone number',
            variant: 'danger',
          },
        })
        return
      }
      this.sendLoading = true
      sendForgetPasswordSms({
        phone: `${this.resetPasswordForm.phoneQh} ${this.resetPasswordForm.phone}`,
      })
        .then((res) => {
          console.log(res)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'SUCCESS',
              icon: 'BellIcon',
              text: 'send success',
              variant: 'success',
            },
          })
          this.sendLoading = false
          this.sendTimes = 60
          this.sendTimer = setInterval(() => {
            if (this.sendTimes > 0) {
              this.sendTimes--
            } else {
              clearInterval(this.sendTimer)
            }
          }, 1000)
        })
        .catch((err) => {
          this.sendLoading = false
        })
    },
    cancel() {
      this.$store.commit('getIsInitPassWordStatus', false)
    },
    cancelResetBlock() {
      this.showResetBlock = false
    },
    closeForget() {
      this.forgetPassword_show = false
      this.resetPasswordForm = {
        phoneQh: '+65',
        type: 'A',
        phone: '',
        newPassword: null,
        confirmNewPassword: null,
        otpCode: null,
      }
    },
    openForget() {
      this.forgetPassword_show = true
    },
    toSms() {
      this.$router.push('/loginBySms')
    },
    handleResetPassword() {
      this.showResetBlock = true
    },
    refreshCode() {
      // getCaptcha().then(res => {
      //   const data = res.data;
      //   this.loginForm.key = data.key;
      //   this.loginForm.image = data.image;
      // })
    },
    i18n(param) {
      return this.$t(`_default.${param}`)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
<style lang="scss" scoped>
// .ant-drawer-body {
//   height: 100%;
// }
.forgetBox {
  ::v-deep .ant-drawer-body {
    height: calc(100% - 51px);
  }
  ::v-deep .ant-drawer-close {
    top: 0;
  }
  ::v-deep .ant-drawer-header {
    border-bottom: none;
  }
}
</style>
